module.exports = __webpack_public_path__ + "img/altfBanner.e6e68850.svg";